import 'bootstrap/dist/css/bootstrap.min.css'
import './User.css'
import { useState } from 'react'
import Login from './Login'
import Register from './Register'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import Button from 'react-bootstrap/Button'

function User() {

    const [user, setUser] = useState()
    const [showRegister, toggleRegister] = useState(false)
    const [showLogin, toggleLogin] = useState(false)
    const navigate = useNavigate()
    const logout = () => {
        sessionStorage.removeItem('jwt')
        setUser(undefined)
        navigate('/')
    }
    useEffect(() => {
        const token = sessionStorage.getItem('jwt')
        const tokenUser = token && parseToken(token)
        setUser(tokenUser)
    }, [])
    return (
        <div className='user-container'>
            {
                user ?
                    <AuthUser user={user} onLogOut={logout} />
                    :
                    <SignOperations
                        onLogin={() => toggleLogin(true)}
                        onRegister={() => toggleRegister(true)} />
            }
            {showRegister && <Register showRegister={showRegister} toggle={toggleRegister} />}
            {showLogin && <Login showLogin={showLogin} toggle={toggleLogin} setUser={setUser} />}

        </div>
    )
}
function parseToken(token) {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace('-', '+').replace('_', '/')
    const { username, role } = JSON.parse(window.atob(base64))
    return { username, role }
}

function AuthUser({ user, onLogOut }) {
    return (
        <div className='user auth'>
            <div className='user-info'>
                <label>Username:</label>
                <span>{user.username}</span>
            </div>
            {/*  <div className='role'>
                <label>Role:</label>
                <span> {user.role} </span>
            </div> */}

            <div className='logout'>
                <div className='role'>{[user.role]}</div>
                <Button variant="light" onClick={() => onLogOut()}> Logout</Button>
            </div>
        </div>
    )
}

function SignOperations({ onLogin, onRegister }) {
    return (
        <>
            <Button variant="light" className='login open_modal'
                onClick={onLogin}>
                Login
            </Button>
            <Button variant="light" className='register open_modal'
                onClick={onRegister}>
                Register
            </Button>
        </>
    )
}
export default User